// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { MessageBackend as createMessageBackendConfluenceCreateASpace } from '@post-office/message-template--confluence-create-a-space/placements/in-app-v2/confluence-side-nav';

import { MessageBackend as createMessageBackendConfluenceResurrectedUserWelcomeSideBarNudge } from '@post-office/message-template--confluence-resurrected-user-welcome-sidebar-nudge/placements/in-app-v2/confluence-side-nav';

import { MessageBackend as createMessageBackendConfluenceSideNav1On1LoomNudge } from '@post-office/message-template--confluence-side-nav-1-on-1-loom-nudge/placements/in-app-v2/confluence-side-nav';

import { MessageBackend as createMessageBackendConfluenceSideNavCreateASpace } from '@post-office/message-template--confluence-side-nav-create-a-space/placements/in-app-v2/confluence-side-nav';

import { MessageBackend as createMessageBackendConfluenceCreateWithRovoSideNavNudge } from '@post-office/message-template--confluence-create-with-rovo-side-nav-nudge/placements/in-app-v2/confluence-side-nav';

import { MessageBackend as createMessageBackendRovoExtensionInstallCta } from '@post-office/message-template--rovo-extension-install-cta-left-nav/placements/in-app-v2/confluence-side-nav';

import { MessageBackend as createMessageBackendTwcSidenavBanner } from '@post-office/message-template--twc-sidenav-banner/placements/in-app-v2/confluence-side-nav';

import { MessageBackend as createMessageBackendTwcSidenavAaBanner } from '@post-office/message-template--twc-sidenav-a-a-banner/placements/in-app-v2/confluence-side-nav';

import { MessageBackend as createMessageBackendConfluenceRovoOnboardingBanner } from '@post-office/message-template--confluence-rovo-onboarding-banner/placements/in-app-v2/confluence-side-nav';

import { MessageBackend as createMessageBackendConfluence3pToolsNudgeBanner } from '@post-office/message-template--confluence-3p-tools-nudge-banner/placements/in-app-v2/confluence-side-nav';

import { MessageBackend as createMessageBackendRovoNonMauChatCtaJiraConfluenceLeftNav } from '@post-office/message-template--rovo-non-mau-chat-cta-jira-confluence-left-nav/placements/in-app-v2/confluence-side-nav';

import { productionRuntime } from '@post-office/placement-common-v2/placement-runtime';

import { PlacementBackend } from '@post-office/placements--growth/confluence-side-nav';

import { type PlacementRestMiddlewareConfig } from '@post-office/placement-common-v2';

import { type PlacementBackendRuntime } from '@post-office/placement-common-v2/create-placement/types';

const messageBackends = [
	createMessageBackendConfluenceCreateASpace({ messageTemplateId: 'confluence-create-a-space' }),
	createMessageBackendConfluenceSideNavCreateASpace({
		messageTemplateId: 'confluence-side-nav-create-a-space',
	}),
	createMessageBackendConfluenceSideNav1On1LoomNudge({
		messageTemplateId: 'confluence-side-nav-1-on-1-loom-nudge',
	}),
	createMessageBackendConfluenceResurrectedUserWelcomeSideBarNudge({
		messageTemplateId: 'confluence-resurrected-user-welcome-sidebar-nudge',
	}),
	createMessageBackendConfluenceCreateWithRovoSideNavNudge({
		messageTemplateId: 'confluence-create-with-rovo-side-nav-nudge',
	}),
	createMessageBackendRovoExtensionInstallCta({
		messageTemplateId: 'rovo-extension-install-cta-left-nav',
	}),
	createMessageBackendTwcSidenavBanner({ messageTemplateId: 'twc-sidenav-banner' }),
	createMessageBackendTwcSidenavAaBanner({ messageTemplateId: 'twc-sidenav-a-a-banner' }),
	createMessageBackendConfluenceRovoOnboardingBanner({
		messageTemplateId: 'confluence-rovo-onboarding-banner',
	}),
	createMessageBackendConfluence3pToolsNudgeBanner({
		messageTemplateId: 'confluence-3p-tools-nudge-banner',
	}),
	createMessageBackendRovoNonMauChatCtaJiraConfluenceLeftNav({
		messageTemplateId: 'rovo-non-mau-chat-cta-jira-confluence-left-nav',
	}),
];

export const placementBackendFactory: (runtime: PlacementBackendRuntime) => PlacementRestMiddlewareConfig = PlacementBackend.createPlacementBackend({
	messageTemplates: messageBackends,
});

export const middleware: PlacementRestMiddlewareConfig = placementBackendFactory(productionRuntime);
